import { render, staticRenderFns } from "./OptimizedImage.vue?vue&type=template&id=2724a320&scoped=true"
import script from "./OptimizedImage.vue?vue&type=script&lang=js"
export * from "./OptimizedImage.vue?vue&type=script&lang=js"
import style0 from "./OptimizedImage.vue?vue&type=style&index=0&id=2724a320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724a320",
  null
  
)

export default component.exports